import type { ThemeMeta, ThemeTokens } from '@/previewThemes/meta';

export const tokens: ThemeTokens = {
  headingFont: null,
  accent: null,
  monoFont: null,
  headingTracking: '-0.02em',
  headingTransform: 'uppercase',
  containerMax: '84rem',
  spaceScale: 1.1,
  headerHeight: '8.5rem',
};

export const meta: ThemeMeta = {
  label: 'Bold',
  hint: 'Heavy type and full-width colour. Impossible to miss.',
  industries: ['general', 'bakery', 'restaurant_food_delivery', 'health_wellness', 'pharmacy_medical', 'clinics'],
  look: {
    // Heavy type wants a flat, saturated ground under it - a gradient or a
    // tint would take the edge off the one thing this theme is doing.
    colors: {
      primary: '#f2542d',
      background: '#ffffff',
      surface: '#fdf2ec',
      text: '#111111',
      muted: '#6b6b6b',
    },
    typography: { font_family: 'Poppins', heading_weight: '800' },
    buttons: { radius_px: 4, style: 'solid' },
    catalog: 'grocery',
  },
};
